import React from 'react';
import {OrdinarBox} from './Ordinar/OrdinarBox';
import {useDispatch} from "react-redux";
import {REMOVE_COUPON_EVENT} from "../../../store/spirs/actions";
import {CouponEvent} from "../../../store/spirs/reducers/couponReducer";
import { ScrollContainer } from '../scrollContainer';

interface IOrdinarListProps {
    couponEvents: CouponEvent[];
}

export function OrdinarList(props: IOrdinarListProps) {
    const dispatch = useDispatch();
    const {couponEvents} = props;

    function removeEventFromCoupon(selectionId: number | undefined) {
        if (selectionId === undefined) {
            throw Error('selectionId must be number, undefined passed');
        } else {
            dispatch(REMOVE_COUPON_EVENT(selectionId));
        }
    }

    return (
        <div className="rounded-[8px] bg-[#272D33] overflow-hidden">
            { couponEvents.length ? <ScrollContainer className="overflow-y-auto max-h-[calc(100vh-390px)]">
                {couponEvents.map((event) => (
                    <div className="bg-[#272D33]" key={event.selectionId}>
                        <OrdinarBox
                            event={event}
                            removeEventFromCoupon={() => removeEventFromCoupon(event.selectionId)}
                            index={event.selectionId}
                        />
                    </div>
                ))}
            </ScrollContainer> : null}
        </div>
    );
}
